import { gql } from '@apollo/client';

import { PAS_FIND_FRAGMENT } from './getSitePasFindsQuery';

export const UPLOAD_AMCR_FIND_PHOTO_MUTATION = gql`
  mutation UploadAmcrFindPhotoMutation($findId: ID!, $file: Upload!) {
    uploadAmcrFindPhoto(findId: $findId, file: $file) {
      ... on UpdateFindSuccess {
        find {
          ...PasFindFields
          amcrData(cacheOnly: false) {
            images
            files {
              id
              name
              sha512
              uploadedName
            }
          }
        }
      }
      ... on ValidationError {
        errors {
          error
          path
        }
      }
    }
  }
  ${PAS_FIND_FRAGMENT}
`;
